import { cn } from "./cn.js";

/** A single focus ring for all interactive elements — it must be added to raw
 *  <button>/tile/rows that cannot be a Button. */
export const focusRing =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-strong/60";

/** Base for a list row-button (full-width elements such as a project picker
 *  row). The consumer adds the hover/selected state. */
export const rowButton = cn(focusRing, "w-full text-left transition-colors");

/** A large clickable tile (OverlayBoard) — the base state. */
export const tileButton = cn(
  focusRing,
  "relative overflow-hidden rounded-md border border-border bg-surface text-ink-soft transition-colors",
  "hover:bg-surface-elevated hover:border-border-strong hover:text-ink",
);

/** The on-air tile state — with a left live stripe (used together with tileButton,
 *  in the form cn(tileButton, active && tileOnAir)). */
export const tileOnAir =
  "border-live bg-live-soft text-live before:absolute before:inset-y-0 before:left-0 before:w-[3px] before:bg-live";
